<template>
    <div class="project-item-block w-1/2 h-auto px-3 mb-6">
        <div class="flex flex-col shadow-md bg-white rounded p-4 h-full" :class="darkMode ? `bg-gray-200` : ``">
            <div class="flex flex-wrap items-center">
                <div
                    class="w-16 h-16 bg-gray-300 rounded-full flex items-center justify-center text-gray-400"
                    :class="darkMode ? `bg-gray-400` : ``"
                >
                    <font-awesome
                        icon="folder"
                        class="fa-2x"
                        :class="hasManager ? 'text-'+manager.color : 'text-gray-500'"
                    ></font-awesome>
                </div>
                <div class="ml-4">
                    <h2 class="text-lg">{{ project.name }}</h2>
                    <h4 class="text-sm mt-1 text-gray-400">{{ project.slogan || "Bez pod-nadpisu" }}</h4>
                </div>
    
                <md-menu class="ml-auto" md-size="small">
                    <md-button class="md-icon-button" md-menu-trigger>
                        <md-icon>more_vert</md-icon>
                    </md-button>
        
                    <md-menu-content>
                        <md-menu-item :to="{ name: 'projects.detail', params: { projectId: project.id }, hash: '#nastavenia' }">
                            <md-icon>edit</md-icon>
                            <span>Upraviť</span>
                        </md-menu-item>
            
                        <md-menu-item to="/" exact>
                            <md-icon>delete</md-icon>
                            <span>Zmazať</span>
                        </md-menu-item>
                    </md-menu-content>
                </md-menu>
            </div>
            <!-- y -->
            <div class="flex items-start mt-6 -mx-4">
                <div class="w-1/5 px-4">
                    <span class="mb-1 block text-gray-500">Stav</span>
                    <div
                        class="rounded text-center font-bold text-sm py-1"
                        :class="darkMode && project.status.color !== 'gray'  ? `bg-${project.status.color}-900 text-${project.status.color}-600` :`bg-${project.status.color}-100 text-${project.status.color}-400`"
                    >{{ project.status.name }}</div>
                </div>
                <div class="w-1/5 px-4">
                    <span class="mb-1 block text-gray-500">Dátum odovz.</span>
                    <div
                        class="rounded text-center font-bold text-sm py-1 bg-gray-100 text-gray-500"
                    >{{ getFormattedDate(project.due_date, "DD.MM.YYYY") || "Neurčené" }}</div>
                </div>
                <div class="w-3/5 px-4">
                    <span class="mb-1 block text-gray-500">Postup</span>
                    <div class="flex items-center mt-1 w-full">
                        <div class="h-2 w-full rounded-full" :class="darkMode ? `bg-gray-300` : `bg-gray-200`">
                            <div
                                class="h-2 rounded-full"
                                :class="darkMode && project.status.color !== 'gray' ? `bg-${project.status.color}-700` : 'bg-'+project.status.color+'-400 '"
                                :style="{width: project.progress+'%'}"
                            ></div>
                        </div>
                        <span class="ml-2 text-gray-600">{{ project.progress.toFixed(0) }}%</span>
                    </div>
                </div>
            </div>
            <!-- desc -->
            <div class="flex my-6">
                <p class="text-gray-400 text-sm">{{ project.description || "Bez popisu" }}</p>
            </div>
            <!-- x -->
            <div class="flex flex-wrap -mx-4 mb-6">
                <div class="w-1/5 px-4">
                    <span class="mb-1 block text-gray-500">Manažér</span>
                    <div
                        class="rounded font-bold text-sm py-1 text-center"
                        :class="(darkMode ? `bg-gray-100` : `bg-gray-100`) + ' text-'+(hasManager ? manager.color : darkMode ? 'gray-500' : 'gray-300')"
                    >{{ hasManager ? shortifyName(manager.name) : "Bez manažéra"}}</div>
                </div>
                <div class="w-1/5 px-4">
                    <span class="mb-1 block text-gray-500">Dátum vzniku</span>
                    <div
                        class="rounded text-center font-bold text-sm py-1 bg-gray-100 text-gray-500"
                    >{{ getFormattedDate(project.created_at, "DD.MM.YYYY") }}</div>
                </div>
                <div class="w-3/5 px-4">
                    <span class="block text-gray-500">Členovia</span>
                    <div class="flex">
                        <span
                            class="rounded text-center px-4 font-bold mt-1 text-sm py-1 bg-gray-100 text-gray-500"
                            v-if="project.members.length === 0">
                            Bez členov
                        </span>
                        <span
                            v-for="(member, index) in project.members.slice(0, 4)"
                            :key="'pmember'+member.id"
                            class="-mt-1 flex items-center justify-center rounded-full w-10 h-10 border-4 border-white text-xs text-white"
                            :class=" member.color.length === '' ? 'bg-gray-300' : 'bg-'+member.color+' '+ (index === 0 ? '' : '-ml-2')">
                            <md-tooltip md-direction="bottom">{{ member.name }}</md-tooltip>
                            {{ getInicials(member) }}
                        </span>
                        <span
                            v-if="project.members.length > 4"
                            class="-mt-1 text-white text-xs flex items-center justify-center bg-gray-500 rounded-full w-10 h-10 border-4 border-white -ml-2"
                        >+{{ project.members.length - 4 }}</span>
                    </div>
                </div>
            </div>
            <!-- foot -->
            <div class="flex items-center border-t border-gray-200 mt-auto pt-3 pl-3">
                <div class="flex items-center">
                    <span class="text-orange-500 text-sm">
                        <font-awesome class="text-gray-600 mr-1" :icon="'list'"></font-awesome>
                        {{ project.task_count }} úloh
                    </span>
                    <span class="text-orange-500 text-sm ml-6">
                        <font-awesome class="text-gray-600 mr-1" :icon="['far', 'clock']"></font-awesome>
                        {{ totalTime }}
                    </span>
                </div>
                <div class="ml-auto">
                    <md-button :to="{ name: 'projects.detail', params: { projectId: project.id } }" class="md-raised md-accent">Detail</md-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { shortifyName, getInicials, formatTotal } from "../../utils";
import {mapState} from "vuex";

export default {
    name: "ProjectItem",
    props: {
        project: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapState({
            darkMode: state => state.darkMode.enabled
        }),
        
        hasManager() {
            return this.project.managers.length !== 0;
        },

        manager() {
            return this.project.managers[0];
        },

        totalTime() {
            return formatTotal(this.project.totalTime);
        }
    },

    methods: {
        getFormattedDate(date, format = "DD.MM.YYYY HH:mm:ss") {
            if (!date) return null;
            return moment.unix(date).format(format);
        },
        
        shortifyName(name) {
            return shortifyName(name);
        },
        
        getInicials(user) {
            return getInicials(user.name, user.image);
        },
    }
};
</script>